import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ContentComponent,
  SingleCardLayoutComponent,
  ButtonComponent,
} from '@lyceo/shared/ui';

@Component({
  selector: 'lib-not-found-page',
  imports: [
    ContentComponent,
    SingleCardLayoutComponent,
    ButtonComponent,
    TranslocoDirective,
  ],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPageComponent {
  private readonly router: Router = inject(Router);
  private readonly authFacade: AuthFacade = inject(AuthFacade);

  protected readonly isAuthenticated: Signal<boolean> =
    this.authFacade.isAuthenticated;

  public home(): void {
    this.router.navigate(['/home']);
  }
}
